import { externalLinks, links } from 'utils/constants'

export const prefixes = [externalLinks.UPSPACE_FULL_PATH, externalLinks.DYNAMIC_LINK_PATH]

export const defaultRootStackScreens = {
  [links.EDIT_WORKOUT_PAGE]: '/post/:postId/edit',
  [links.CREATE_WORKOUT_PAGE]: '/post/create',
  [links.CREATE_POST_PAGE]: '/post/create-simple',
  [links.POST_PAGE]: '/post/:postId',
  [links.CHAT_ROOM]: '/chat/:roomId',
  [links.LEADERBOARD_PAGE]: '/leaderboard/:trainerId',
  [links.UPSCORE_PAGE]: '/upscore/:userId',
  [links.PROGRAM_PAGE]: '/program/:programId',
  [links.EDIT_PROGRAM_PAGE]: '/program/edit/:programId',
  [links.ACTIONS_LIST_PAGE]: '/program/actions/:programId',
  // The main tab bar that sits at the bottom of the app
  [links.MAIN_TABS]: {
    screens: {
      [links.HOME_STACK]: {
        screens: {
          [links.FEED_PAGE]: '/feed/:tab?',
          [links.NOTIFICATIONS_PAGE]: '/feed/notifications',
          [links.TRAINERS_PAGE]: '/feed/groups',
          [links.WORKOUTS_PAGE]: '/feed/workouts',
          [links.SHARE_PROFILE_PAGE]: '/feed/share',
          [links.EXPLORE_PAGE]: '/explore',
          [links.TRAINERS_PAGE]: '/explore/groups',
          [links.WORKOUTS_PAGE]: '/explore/workouts',
        },
      },
      [links.NOTIFICATIONS_STACK]: {
        screens: {
          [links.NOTIFICATIONS_PAGE]: '/notifications',
        },
      },
      [links.CHAT_STACK]: {
        screens: {
          [links.CHAT_PAGE]: '/chat/:tab?',
        },
      },
      [links.PROFILE_STACK]: {
        screens: {
          [links.PROFILE_PAGE]: '/profile/:tab?',
          [links.FOLLOWERS_FRIENDS_PAGE]: '/profile/followers/:tab?',
          [links.MEMBER_PROFILE_PAGE]: '/profile/member/:username',
          [links.EDIT_PROFILE_PAGE]: '/profile/edit',
          [links.SHARE_PROFILE_PAGE]: '/profile/share',
          [links.ACCOUNT_PAGE]: '/profile/account',
          [links.MEMBERSHIPS_PAGE]: '/profile/memberships',
          [links.UPSPACE_SETTINGS_PAGE]: '/profile/account/group-settings',
          [links.NOTIFICATION_SETTINGS_PAGE]: '/profile/account/notification-settings',
          [links.WORKOUTS_PAGE]: '/profile/workouts',
          [links.TRAINERS_PAGE]: '/profile/discover/group',
        },
      },
      [links.GROUP_STACK]: {
        screens: {
          [links.GROUP_PAGE]: 'group/:username',
          [links.SHARE_GROUP_PAGE]: 'group/share/:username',
          [links.ACCOUNT_PAGE]: 'group/account',
          [links.GROUP_SETTINGS_PAGE]: 'group/edit',
          [links.FOLLOWERS_MEMBERS_PAGE]: 'group/followers-members/:trainer',
          [links.LEADERBOARD_PAGE]: 'group/leaderboard/:trainerId',
          [links.MEMBER_PROFILE_PAGE]: 'group/profile/:username',
        },
      },
    },
  },
}
